import { render, staticRenderFns } from "./AddGroupQuestions.vue?vue&type=template&id=6202c650"
import script from "./AddGroupQuestions.vue?vue&type=script&lang=js"
export * from "./AddGroupQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports